import { render } from "./ModalExcluirSolicitacao.vue?vue&type=template&id=804bcb80&scoped=true"
import script from "./ModalExcluirSolicitacao.vue?vue&type=script&lang=js"
export * from "./ModalExcluirSolicitacao.vue?vue&type=script&lang=js"

import "./ModalExcluirSolicitacao.vue?vue&type=style&index=0&id=804bcb80&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-804bcb80"]])

export default __exports__